export const ACTION_TYPES = {
  SET_POLYGON: 'CHANGE_POLYGON',
  SET_ADDRESS_OPTIONS: 'SET_ADDRESS_OPTIONS',
  SET_SEARCH: 'SET_SEARCH',
  SET_SEARCH_TIMER: 'SET_SEARCH_TIMER',
  SET_REQUEST_TIMER: 'SET_REQUEST_TIMER',
  SET_SEARCHING_BY_ADDRESS: 'SET_SEARCHING_BY_ADDRESS',
  SET_LOADING: 'SET_LOADING',
};
